/* eslint-disable max-len */
import IconCopy from '@/assets/images/oversight-icons/copy.svg';
import IconTxtFile from '@/assets/images/oversight-icons/txt-file.svg';
import { IconArrowForwardIosMS, IconKeyboardArrowUp } from '@/constants/icons';
import useErrorMessage from '@/hooks/useErrorMessage';
import useSnackbar from '@/hooks/useSnackbar';
import { WarningOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';

import { Button } from '../Button';
import { TimelineItemProps } from './data';
import {
  AuditTag,
  ContainerError,
  ContainerErrorMessage,
  ContainerErrorTitle,
  ItemBadge,
  ItemContainer,
  ItemIndicator,
  ItemLine,
  ItemMessage,
  ItemMessageLink,
  ItemMessageWrapper,
  ItemTime,
  TitleErrorMessage,
} from './styles';

export function TimelineItem({
  time,
  message,
  status,
  isAuditable = false,
  isLink = false,
  isLast = false,
  isFirst = false,
  onClick,
}: TimelineItemProps): JSX.Element {
  const [openErrorMessage, setOpenErrorMessage] = useState(false);
  const errorMessage =
    'File "/usr/local/lib/python3.11/site-packages/sqlalchemy/engine/base.py", line 1705, in _execute_20';

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();

  const handleOpenErrorDetails = (): void => {
    setOpenErrorMessage((prev) => !prev);
  };

  const handleCopy = async (text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      handleSnackbar('copiado para a área de transferência', false);
    } catch (err) {
      handleSnackbar(getErrorMessage(err), true);
    }
  };

  return (
    <ItemContainer>
      <ItemTime>{time}</ItemTime>

      <ItemIndicator>
        <ItemLine isFirst={isFirst} isLast={isLast} />
        <ItemBadge status={status} />
      </ItemIndicator>

      <ItemMessageWrapper>
        {isLink ? (
          <ItemMessageLink onClick={onClick}>{message}</ItemMessageLink>
        ) : (
          <div>
            <ItemMessage>{message}</ItemMessage>
            {isAuditable && <AuditTag>crítico</AuditTag>}
          </div>
        )}

        {status === 'error' && (
          <Button variant="text" onClick={handleOpenErrorDetails}>
            Ver detalhes{' '}
            {openErrorMessage ? IconKeyboardArrowUp : IconArrowForwardIosMS}
          </Button>
        )}
      </ItemMessageWrapper>
      {openErrorMessage && (
        <ContainerError>
          <ContainerErrorTitle>
            <TitleErrorMessage>
              <WarningOutlined fontSize="small" />
              <span>Permissão Insuficiente</span>
            </TitleErrorMessage>

            <div>
              <IconButton onClick={() => handleCopy(errorMessage)}>
                <img src={IconCopy} alt="botão de copiar" />
              </IconButton>
              <IconButton>
                <img src={IconTxtFile} alt="botão de exportar em .txt" />
              </IconButton>
            </div>
          </ContainerErrorTitle>
          <ContainerErrorMessage>
            <p>{errorMessage}</p>
          </ContainerErrorMessage>
        </ContainerError>
      )}
    </ItemContainer>
  );
}
